// const API_BASE_URL = "http://localhost:4001/api";
const API_BASE_URL = "https://vishal-hardware-portfolio.onrender.com/api";

export const API_ENDPOINTS = {
  auth: {
    register: `${API_BASE_URL}/auth/register`,
    login: `${API_BASE_URL}/auth/login`,
  },
  vishalContact: {
    create: `${API_BASE_URL}/vishal/contact/createContact`,
    getAll: `${API_BASE_URL}/vishal/contact/getContacts`,
    export: `${API_BASE_URL}/vishal/contact/export`,
  },
  pentagonContact: {
    create: `${API_BASE_URL}/pentagon/contact/createContact`,
    getAll: `${API_BASE_URL}/pentagon/contact/getContacts`,
    export: `${API_BASE_URL}/pentagon/contact/export`,
  },
};
